import { combineReducers } from "redux";
import { headerReducer } from "./header_reducer";
import {jwtAuthreducer} from "./jwtAuth_reducer";
import { debateListReducer } from "./debate_list_reducer";
import { avatarReducer } from "./avatar_reducer"; 
import { joiningDebateReducer } from "./joining_debate_reducer";
import { debateDetailsReducer } from "./debate_details_reducer";
import { topicReducer } from "./websockt_reducer/topic";
import { debateTimerReducer } from "./debate_time_reducer";
import { roomIdReducer } from "./websockt_reducer/roomId_reducer";
import { getAllAvatarReducer } from "./get_all_joined_member_reducer";
import { votingReducer } from "./websockt_reducer/voting_reducer";
import { counterStatementReducer } from "./websockt_reducer/counter_statement_reducer";
import { removeMemberReducer } from "./remove_member_reducer";
import { finishDebateReducer } from "./websockt_reducer/finishe_debate_reducer";
import { subscriptionReducer } from "./subscription_reducer";
import { getUserSubscriptionDetails } from "./get_user_subscription_reducer";
import { getRemainingDebateReducer } from "./check_remaining_debate_reducer";
const reducers = combineReducers({
    headerReducer,
    jwtAuthreducer,
    debateListReducer,
    avatarReducer,
    joiningDebateReducer,
    debateDetailsReducer,
    topicReducer,
    debateTimerReducer,
    roomIdReducer,
    getAllAvatarReducer,
    votingReducer,
    counterStatementReducer,
    removeMemberReducer,
    finishDebateReducer,
    subscriptionReducer,
    getUserSubscriptionDetails,
    getRemainingDebateReducer,

});

export default reducers;